const blog = {
  'blog.page.backToTop': 'ページの先頭へ戻る',
  'blog.page.lastUpdated': '最終更新: 2026年6月13日',

  'blog.hero.homeLink': 'ホーム',
  'blog.hero.currentPage': 'ブログ',
  'blog.hero.title': '執事の知恵袋',
  'blog.hero.titleEn': 'BUTLER\'S BLOG',
  'blog.hero.lead': '執事の技術・マナー・キャリアについて、アカデミー講師が実務経験を交えて解説します。',
  'blog.hero.imgAlt': '書斎で執事が書物を手にしている様子',

  'blog.list.all': 'すべて',
  'blog.list.empty': 'このカテゴリの記事はまだありません。',
  'blog.list.readMore': '続きを読む',
  'blog.list.categoryTitle': 'カテゴリ一覧',

  'blog.cat.A': '執事の基礎知識',
  'blog.cat.B': '執事のキャリア',
  'blog.cat.C': '作法・マナー実践',
  'blog.cat.D': 'アカデミー便り',
  'blog.cat.E': '業界・海外事情',

  'blog.detail.backToList': 'ブログ一覧に戻る',
  'blog.detail.authorLabel': '著者',
  'blog.detail.tocTitle': '目次',
  'blog.detail.relatedTitle': '関連記事',
  'blog.detail.shareTitle': 'この記事をシェア',
  'blog.detail.updatedLabel': '更新日',
  'blog.detail.publishedLabel': '公開日',
};

export default blog;
